import * as React from 'react';

import {Circle, Path} from 'react-native-svg';

import Icon from './Icon';
import {IconProps} from './type';

const BorderRightTickIcon: React.FC<IconProps> = props => {
  return (
    <Icon {...props}>
      <Circle
        cx={19}
        cy={19}
        r={17.693}
        fill="#100E3A"
        stroke="#fff"
        strokeWidth={1.386}
      />
      <Path
        stroke="#fff"
        strokeWidth={4.969}
        d="m10.047 18.908 6.943 7.31 10.963-14.436"
      />
    </Icon>
  );
};

export default BorderRightTickIcon;
